module.exports = __webpack_public_path__ + "img/6.900d38a3.gif";